var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "16px",
      "bottom": "8px"
    }
  }, [_c('v-row', {
    staticClass: "ma-n4"
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "320",
      "content-class": "fill-height"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "primary",
          attrs: {
            "icon": "",
            "color": "white"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" mdi-view-list ")])], 1)];
      }
    }]),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "fill-height"
  }, [_c('desc-list', _vm._g({
    attrs: {
      "mobile": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, {
    exit: _vm.exit
  }))], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }